import axios from 'axios'
import store from '../store/store'

export default {
  async logEvent (eventName, params) {
    const user = store.getters['auth/getUser']
    let userId = 0
    if (eventName === 'sign_up') {
      userId = params.user_id
    } else if (user) {
      userId = user.id
    }
    if (userId) {
      if (params) {
        params = JSON.stringify(params)
      }
      const submitData = {
        user_id: userId,
        event_name: eventName,
        params: params,
        platform: 'website'
      }
      const url = 'user-event-logs'
      let { data } = await axios.post(url, submitData)
      if (!data.error) {
        console.log('log user event success')
      } else {
        console.log('log user event failed')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/userEventLogHelpers.js